module.exports = __webpack_public_path__ + "img/107065.a21df386.png";